import { createAction } from 'redux-starter-kit';


export const putDamageArea = createAction('PUT_DAMAGE_AREA');
export const putDamageAreas = createAction('PUT_DAMAGE_AREAS');
